import { render, staticRenderFns } from "./LedgerSummary.vue?vue&type=template&id=1b7d67b8"
import script from "./LedgerSummary.vue?vue&type=script&lang=js"
export * from "./LedgerSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports